export type AssetAllocationSegmentKey = 'equities' | 'bonds' | 'cash' | 'other';

// Shared by every household allocation bar and legend so each asset class keeps the same color.
export const ALLOCATION_SEGMENT_COLORS: Record<AssetAllocationSegmentKey, string> = {
    equities: 'bg-seafoam-300',
    bonds: 'bg-gold-400',
    cash: 'bg-cocoa-200',
    other: 'bg-cocoa-400',
};
